import { render, staticRenderFns } from "./CardGrid.vue?vue&type=template&id=071d6dbb&scoped=true&"
import script from "./CardGrid.vue?vue&type=script&lang=js&"
export * from "./CardGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d6dbb",
  null
  
)

export default component.exports